import { COMMON_TRANSFORM_RESPONSE_FUNCTION, LOGGER_ACTION } from "../../../app/constants/api";
import { apiSlice } from "../../../app/redux/apiSlice";

export const AppSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loggerAction: builder.mutation({
      query: ({ action, payload = {} }) => ({
        url: LOGGER_ACTION.BASE,
        method: "POST",
        body: { action, payload },
      }),
      ...COMMON_TRANSFORM_RESPONSE_FUNCTION,
    }),
  }),
});

export const { useLoggerActionMutation } = AppSlice;